import dayjs from "dayjs"
import { useUserSettings } from "api/hooks"

const Date = ({ value }) => {
  const { data: userSettings } = useUserSettings()

  if (!value) return null

  const dateValue = () => {
    if (userSettings?.date_format) {
      return dayjs(value).format(userSettings.date_format)
    }
    return dayjs(value).format("MM/DD/YYYY")
  }

  return <div style={{ whiteSpace: "nowrap" }}>{dateValue()}</div>
}

export default Date
